/*
 * @Description:
 * @Date: 2020-08-26 14:16:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-26 17:45:01
 */
import { getStorage, setStorage } from '@/tools/storage';
const history = {
  state: {
    history: getStorage('projectHistory') || [],
    projectType: 0 // 0执行中 1已完结
  },

  mutations: {
    SET_PROJECT_HISTORY: (state, item) => {
      const arr = [item, ...state.history.filter(i => i.id != item.id)].slice(
        0,
        5
      );
      state.history = arr;
      setStorage('projectHistory', arr);
    },
    SET_PROJECT_TYPE: (state, type) => {
      state.projectType = type;
    }
  },

  actions: {
    setProjectHistory({ commit }, item) {
      commit('SET_PROJECT_HISTORY', item);
    },
    setProjectType({ commit }, type) {
      commit('SET_PROJECT_TYPE', type);
    }
  }
};

export default history;
